import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { select } from '@swf/core/store';
import { Icon } from '@swf/sports/components';

import { useGetExtraWalletsAriaLabels } from '../../hooks/useGetExtraWalletsAriaLabels';

import {
  TXTWCL_N0_Bonus_Cash,
  TXTWCL_N0_FREE_BET,
  TXTWCL_N0_FREE_BETS,
  TXTWCL_N0_PROMOTIONS_AVAILABLE
} from './ExtraWalletsTitle.messages.json';
import styles from './ExtraWalletsTitle.scss';

const ExtraWalletsTitle: React.FC = () => {
  const allWallets = useSelector(select.extraWallets.getAllEnabledWallets);
  const freeBetsWallets = useSelector(select.extraWallets.getFreeBetsWallets);
  const totalBonusCashBalance = useSelector(select.extraWallets.getTotalBonusCashBalance);
  const totalFreeBetsBalance = useSelector(select.extraWallets.getTotalFreeBetsBalance);
  const extraWalletsCurrency = useSelector(select.extraWallets.getExtraWalletsCurrency);
  const walletsByAccountCurrency = useSelector(select.extraWallets.getWalletsByAccountCurrency);
  const { freeBetsLabel, promotionsAvailableLabel } = useGetExtraWalletsAriaLabels();

  const hasBonusCash = !!totalBonusCashBalance;
  const hasFreeBets = !!totalFreeBetsBalance;
  const hasBonusCashAndFreeBets = hasBonusCash && hasFreeBets;
  const hasPromotionWalletsInOtherCurrency = walletsByAccountCurrency.length !== allWallets.length;

  if (hasBonusCashAndFreeBets || hasPromotionWalletsInOtherCurrency) {
    return (
      <h2 className={styles.summaryTitle} aria-label={promotionsAvailableLabel}>
        <Icon name="gift" size="xl" />
        <Translation {...TXTWCL_N0_PROMOTIONS_AVAILABLE} values={{ 0: allWallets.length }} />
      </h2>
    );
  }

  if (hasBonusCash) {
    return (
      <h2 className={styles.summaryTitle}>
        <Icon name="cash" size="xl" />
        <Translation
          {...TXTWCL_N0_Bonus_Cash}
          values={{
            0: (
              <CurrencyAmount
                value={totalBonusCashBalance}
                dollarValue
                currency={extraWalletsCurrency}
              />
            )
          }}
        />
      </h2>
    );
  }

  if (hasFreeBets) {
    return (
      <h2 className={styles.summaryTitle} aria-label={freeBetsLabel}>
        <Icon name="free-bet-sb" size="x1" className={styles.freeBetIcon} />
        <Translation
          {...(freeBetsWallets.length === 1 ? TXTWCL_N0_FREE_BET : TXTWCL_N0_FREE_BETS)}
          values={{
            0: (
              <CurrencyAmount
                value={totalFreeBetsBalance}
                dollarValue
                currency={extraWalletsCurrency}
              />
            )
          }}
        />
      </h2>
    );
  }

  return null;
};

export default ExtraWalletsTitle;
